<template>
    <span class="clock">
        {{ type === 'remaining' ? remainingTime : elapsedTime }} <i class="fa fa-clock-o" aria-hidden="true"></i>
    </span>
</template>

<script>
    export default {
        data() {
            return {
                maxSeconds:     0,
                secondsElapsed: 0,
                interval:       null,
                isPaused:       false
            };
        },
        props:    ['minutes', 'type'],
        computed: {
            remainingTime() {
                let s = this.maxSeconds - this.secondsElapsed;
                return (s - (s %= 60)) / 60 + (9 < s ? ':' : ':0') + s;
            },
            elapsedTime() {
                let s = this.secondsElapsed;
                return (s - (s %= 60)) / 60 + (9 < s ? ':' : ':0') + s;
            }
        },
        methods:  {
            pause() {
                this.isPaused = true;
            },
            start() {
                this.maxSeconds = (this.minutes || 30) * 60;
                this.interval   = setInterval(() => {
                    if (this.isPaused) return;
                    this.secondsElapsed++;
                    this.$emit('tick', this.secondsElapsed);
                    if (this.secondsElapsed === this.maxSeconds)
                        clearInterval(this.interval);
                }, 1000);
            },
            clear() {
                clearInterval(this.interval);
            },
            restart() {
                this.secondsElapsed = 0;
                this.isPaused       = false;
                this.clear();
                this.start();
            },
            getSecondsElapsed() {
                return this.secondsElapsed;
            }
        },
        created() {
            this.start();
        },
        beforeDestroy() {
            this.clear();
        }
    };
</script>

<style>
    .clock {;
        color: rgb(102, 102, 102);
        //font-size: 16px;
        //font-weight: 700;
        line-height: 18px;
    }
</style>